/**
 * Chart Skeleton Component
 *
 * Loading placeholder for lazy-loaded chart components.
 * Provides visual feedback while chart libraries download.
 */

export function ChartSkeleton() {
  return (
    <div className="animate-pulse space-y-3">
      {/* Chart title skeleton */}
      <div className="h-6 bg-muted rounded w-1/3" />

      {/* Chart body skeleton */}
      <div className="h-[300px] bg-muted/50 rounded-lg flex items-end gap-2 p-4">
        {/* Simulate bar chart with varying heights */}
        {Array.from({ length: 12 }).map((_, i) => (
          <div
            key={i}
            className="flex-1 bg-muted rounded-t"
            style={{
              height: `${Math.random() * 60 + 40}%`,
            }}
          />
        ))}
      </div>
    </div>
  );
}

/**
 * Compact Chart Skeleton
 *
 * Smaller skeleton for charts in grid layouts.
 */
export function CompactChartSkeleton() {
  return (
    <div className="animate-pulse space-y-2">
      <div className="h-5 bg-muted rounded w-1/2" />
      <div className="h-[200px] bg-muted/50 rounded-lg" />
    </div>
  );
}
